import { createSlice, createAsyncThunk, isAllOf } from '@reduxjs/toolkit'
import { toast } from 'react-toastify'
import httpService from '../../common/http.service'

// export const appAllGetEventBooking = createAsyncThunk(
// 	'appEventBooking/appAllGetEventBooking',
// 	async params => {
// 		try {
// 			let url = `/eventbooking?page=${params.page}&limit=${params.limit}`
// 			if (params.hub) {
// 				url += `&hub=${params.hub}`
// 			}
// 			if (params.sanstha) {
// 				url += `&sansthaId=${params.sanstha}`
// 			}
// 			if (params.startDate) {
// 				url += `&startDate=${params.startDate}`
// 			}
// 			if (params.endDate) {
// 				url += `&endDate=${params.endDate}`
// 			}
// 			const response = await httpService.get(url)
// 			return await response.data.data
// 		} catch (error) {
// 			toast.error(error?.message)
// 		}
// 	},
// )

export const appAllGetEventBooking = createAsyncThunk(
	'appEventBooking/appAllGetEventBooking',
	async (params = {}) => {
		try {
			const { page = 1, limit = 10, loading = true, hub, sanstha, startDate, endDate } = params

			let url = `/eventbooking?page=${page}&limit=${limit}`

			if (hub) url += `&hub=${hub}`
			if (sanstha) url += `&sansthaId=${sanstha}`
			if (startDate) url += `&startDate=${startDate}`
			if (endDate) url += `&endDate=${endDate}`

			const response = await httpService.get(url, {}, {}, { loading })

			return response.data.data
		} catch (error) {
			toast.error(error?.message || 'Failed to fetch event bookings')
			throw error
		}
	},
)

export const appUpdateEventBooking = createAsyncThunk(
	'appEventBooking/appUpdateEventBooking',
	async params => {
		//  console.log(params, "params");
		try {
			const response = await httpService.put(
				`/eventbooking/${params.id}`,
				{},
				{
					status: params.status,
					rejectionreason: params.rejectionreason,
				},
			)
			//   console.log(response, "response");
			return await response.data
		} catch (error) {
			toast.error(error?.message)
		}
	},
)

export const appDeleteEventBooking = createAsyncThunk(
	'appEventBooking/appDeleteEventBooking',
	async id => {
		try {
			const response = await httpService.delete(`/eventbooking/${id}`)
			if (response?.data) {
				response.data.id = id
				toast.success('Facility Booking Deleted Successfully')
			}
			return await response.data
		} catch (error) {
			toast.error(error?.message)
		}
	},
)

export const appEventBookingSlice = createSlice({
	name: 'Event booking',
	initialState: {
		eventlist: [],
		isloder: false,
		paginate: '',
		isdeleted: false,
	},
	reducers: {},
	extraReducers: builder => {
		builder.addMatcher(isAllOf(appAllGetEventBooking.pending), (state, action) => {
			state.isloder = true
		})
		builder.addMatcher(isAllOf(appAllGetEventBooking.fulfilled), (state, action) => {
			state.eventlist = action.payload
			const paginate = {
				hasNextPage:
					action?.payload?.pagination?.totalPages > action?.payload?.pagination?.currentPage,
				hasPrevPage: action?.payload?.pagination?.currentPage > 1,
				limit: action?.payload?.pagination?.pageSize,
				nextPage: action?.payload?.pagination?.currentPage + 1,
				page: action?.payload?.pagination?.currentPage,
				pagingCounter:
					(action?.payload?.pagination?.currentPage - 1) * action?.payload?.pagination?.pageSize +
					1,
				prevPage: action?.payload?.pagination?.currentPage - 1,
				totalDocs: action?.payload?.pagination?.totalRecords,
				totalPages: action?.payload?.pagination?.totalPages,
			}
			state.paginate = paginate
			state.isloder = false
		})
		builder.addMatcher(isAllOf(appAllGetEventBooking.rejected), (state, action) => {
			state.isloder = false
		})
	},
})

export default appEventBookingSlice.reducer
